import { render, staticRenderFns } from "./ProdEntrees.vue?vue&type=template&id=c62c847a&scoped=true&"
import script from "./ProdEntrees.vue?vue&type=script&lang=js&"
export * from "./ProdEntrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62c847a",
  null
  
)

export default component.exports